import React, { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'

import styled, { useTheme } from 'styled-components/native'

import { ProviderUser } from '@lyrahealth-inc/shared-app-logic/src/models/user/User'
import { BodyText } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { EditIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/EditIcon'
import { PressableOpacity } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/pressableOpacity/PressableOpacity'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

import { getTotalCapacity } from '../../utils/utils'

const Container = styled(PressableOpacity)(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing['8px'],
  padding: theme.spacing['12px'],
  borderRadius: '8px',
  border: `1px solid ${theme.colors.borderDefault}`,
}))

type CapacitiesCalendarProps = {
  provider: ProviderUser
  handleUpdateClick: () => void
}

const CapacitiesCalendar: React.FC<CapacitiesCalendarProps> = ({ provider, handleUpdateClick }) => {
  const theme = useTheme()
  const totalCapacity = useMemo(() => getTotalCapacity(provider.capacity_value), [provider.capacity_value])

  return (
    <Container testID={tID('CapacitiesCalendar')} onPress={handleUpdateClick}>
      <BodyText
        text={
          totalCapacity > 0 ? (
            <FormattedMessage
              defaultMessage='Accepting {totalCapacity, plural, one {# new client} other {# new clients}}'
              description='Text displaying the total number of available spots for the provider'
              values={{ totalCapacity }}
            />
          ) : (
            <FormattedMessage
              defaultMessage='Not accepting new clients'
              description='Text displaying that the provider has no available spots'
            />
          )
        }
      />
      <EditIcon isFilled={false} size={24} fillColor={theme.colors.iconDefault} />
    </Container>
  )
}

export default CapacitiesCalendar
